import { get, set } from 'lodash';
import { ASSIGN_VENDORS_TO_WAREHOUSE_ROUTE } from '../assignVendorsToWarehousePage';

export default {
    name: 'warehouseGridPage',
    before: [],
    after: [],
    setup: (app) => {
        const routeName = 'warehouses';
        const route = app.routes.getItem(routeName);
        if (route) {
            const customGridData = (gridProps, props) => {
                const rowOptions = get(gridProps, 'config.rowOptions', []);

                rowOptions.push({
                    id: 'assignVedors',
                    icon: 'edit',
                    label: 'Assign Vendors',
                    handler: ({ id }) =>
                        props.history.push({
                            pathname: `${ASSIGN_VENDORS_TO_WAREHOUSE_ROUTE}/${id}`,
                            state: { backToGrid: true },
                        }),
                });

                set(gridProps, 'config.rowOptions', rowOptions);

                return gridProps;
            };

            const routeProps = route.props;

            route.props = (state) => ({
                ...routeProps(state),
                customGridData,
            });

            app.routes.changeItem(routeName, route);
        }
    },
};
